<template>
<!--  https://chenxuan0000.github.io/vue-seamless-scroll/zh/guide/-->
  <div class="cpjsBox" :style="{backgroundImage:'url('+backgroundImage+')'}">
<!--    <div class="cpjs_left_i cpjs_i" @click="leftYY" :style="{ backgroundColor: colorData.left }">-->
<!--      <div class="circle-container">-->
<!--        <i class="el-icon-arrow-left"></i>-->
<!--      </div>-->
<!--    </div>-->
    <div class="cpjs_ze">
    <div class="cpjsHeader">
      <div class="cpjs_left">Product Introduction</div>
      <div class="cpjs_right" @click="cpjsCK">View More</div>
    </div>
    <div class="cpjsContentBox">
      <div class="cpjs_item"  v-show="item.showData" v-for="item in cpjsItem" @click="toCpjs(item.path)">
          <div class="cpjs_item_img">
            <el-image
              style="width: 376px; height: 360px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
border-bottom: 2px solid #5daf34;"
              :src="item.imgUrl"
              :fit="contain"></el-image>
          </div>
        <div class="cpjs_item_text1">
          {{item.text1}}
        </div>
        <div class="cpjs_item_text2">
          {{item.text2}}
        </div>
      </div>
    </div>
    </div>
<!--    <div class="cpjs_right_i" @click="rightYY" :style="{ backgroundColor: colorData.right }">-->
<!--      <i class="el-icon-arrow-right cpjs_i"></i>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: "cpjs",
  data() {
    return {
      backgroundImage:"http://116.62.38.250//image/sy/cpjsb.jpg",
      indexUrl: 1,
      colorData:{
        right:"#5daf34",
        left:"#FFFFFF"
      },
      listData: [1, 2, 3, 4, 5, 6],
      classOption: {
        limitMoveNum: 2,
        switchSingleStep: 428,
        direction: 2,
        // autoPlay:false,
        navigation:true
      },
      cpjsItem:[
        {
          path: "cpjs",

          index:1,
          showData:true,
          imgUrl:"http://116.62.38.250/image/sy/cpjs1.jpg",
          text1:"Er:YAG \n" +
            "Dental Laser \n" +
            "Tre- atment System",
          text2:"Using military grade Er: YAG crystal, a laser with a wavelength of 2940nm is generated, which is then dynamically focused on..."
        },
        {
          path: "gzj",
          index:2,
          showData:true,
          imgUrl:"http://116.62.38.250//image/sy/cpjs2.jpg",
          text1:"All-in-One Laser Hand- piece",
          text2:"Adopting a straight bend design, it can achieve a comprehensive and multi angle diagnosis and treatment mode"
        },
        {
          path: "sb",
          index:3,
          showData:true,
          imgUrl:"http://116.62.38.250//image/sy/cpjs3.jpg",
          text1:"Laser Working Tips",
          text2:"Non invasive and adsorption lock design, achieving plug and play, with various diameter and length specifications, can accept high temperature disinfection, achieve reuse, and reduce usage costs."
        }
      ]
    }
  },
  created() {
    let that = this;
    console.log(that.urlData);
    that.indexUrl = that.$route.query.index;
    console.log(that.urlData);
  },
  mounted() {
    let that = this;
    that.init();

  },
  methods:{
    init(){
      let that = this;
      if(that.indexUrl != '' && that.indexUrl != undefined) {
        if(that.indexUrl +2 >  that.cpjsItem.length) {
          for (var i = 0; i < that.cpjsItem.length; i++) {
            let item = that.cpjsItem[i];
            if(i>=(that.indexUrl-1) && i<=(that.indexUrl+2)){
              item.showData = true;
            } else {
              item.showData = false;
            }
          }
          if(that.indexUrl > 1){
            this.colorData.left = '#5daf34'
          } else {
            this.colorData.left = '#FFFFFF'
          }
          if(that.cpjsItem.length > that.indexUrl+2){
            this.colorData.right = '#5daf34'
          } else {
            this.colorData.left = '#FFFFFF'
          }
        } else {
          for (var i = 0; i < that.cpjsItem.length; i++) {
            let item = that.cpjsItem[i];
            if(i<3){
              item.showData = true;
            } else {
              item.showData = false;
            }
          }

          this.colorData.left = '#FFFFFF'

          if(that.cpjsItem.length > 3){
            this.colorData.right = '#5daf34'
          } else {
            this.colorData.left = '#FFFFFF'
          }
        }
      } else {
        that.indexUrl = 1;
        for (var i = 0; i < that.cpjsItem.length; i++) {
          let item = that.cpjsItem[i];
          if(i<3){
            item.showData = true;
          } else {
            item.showData = false;
          }
        }

        this.colorData.left = '#FFFFFF'
        console.log('ttxxx'+that.cpjsItem.length)
        if(that.cpjsItem.length > 3){
          this.colorData.right = '#5daf34'
        } else {
          this.colorData.right = '#FFFFFF'
        }
      }
      console.log(that.indexUrl)
    },
    leftYY(){
      console.log("left")
      let that = this;
      if(that.indexUrl === 1){
        return;
      } else {
        let indexBB = that.indexUrl-1;
        for (var i = 0; i < that.cpjsItem.length; i++) {
          let item = that.cpjsItem[i];
          if(i>=(indexBB-1) && i<(indexBB+2)){
            item.showData = true;
          } else {
            item.showData = false;
          }
        }
        if(indexBB > 1){
          this.colorData.left = '#5daf34'
        } else {
          this.colorData.left = '#FFFFFF'
        }
        if(that.cpjsItem.length > indexBB+2){
          this.colorData.right = '#5daf34'
        } else {
          this.colorData.right = '#FFFFFF'
        }
        that.indexUrl = indexBB;
      }

    },
    rightYY(){
      console.log("right")
      let that = this;
      if(that.indexUrl+3 > that.cpjsItem.length){
        return;
      } else {
        console.log(that.indexUrl)
        let indexBB = that.indexUrl+1;
        for (var i = 0; i < that.cpjsItem.length; i++) {
          let item = that.cpjsItem[i];
          console.log(item)
          console.log(i)
          console.log(indexBB)
          if(i>=(indexBB-1) && i<(indexBB+2)){
            item.showData = true;
          } else {
            item.showData = false;
          }
        }
        if(indexBB > 1){
          this.colorData.left = '#5daf34'
        } else {
          this.colorData.left = '#FFFFFF'
        }
        if(that.cpjsItem.length > indexBB+2){
          this.colorData.right = '#5daf34'
        } else {
          this.colorData.right = '#FFFFFF'
        }
        that.indexUrl = indexBB;
      }
    },
    cpjsCK(){
      this.$router.push('/en/product');
    },
    toCpjs(path){
      this.$router.push('/en/product?path='+path);
    }
  }
}
</script>

<style lang="scss" scoped>
.cpjs_item_img{

}
.cpjs_right_i{
  width: 45px;       /* 圆的宽度 */
  height: 45px;      /* 圆的高度 */
  //background-color: #5daf34; /* 圆的背景颜色 */
  border-radius: 50%; /* 将div变成圆形 */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 200px;
  cursor: pointer;
}
.cpjs_left_i{
  width: 45px;       /* 圆的宽度 */
  height: 45px;      /* 圆的高度 */
  //background-color: #FFFFFF; /* 圆的背景颜色 */
  border-radius: 50%; /* 将div变成圆形 */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 200px;
  cursor: pointer;
}
.cpjsContentBox{
  display: flex;
}
.cpjs_item_text1{
  font-family: SourceHanSansCN;
  font-size: 24px;
  color: #333333;
  letter-spacing: 0.51px;
  text-align: justify;
  margin-top: 30px;
  margin-right: 30px;
  margin-left: 30px;
}
.cpjs_item_text2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
  line-height: 20px;
  margin-top: 30px;

  margin-right: 30px;
  margin-left: 30px;
}
.cpjs_item{
  width: 376px;
  height: 576px;
  margin-right: 10px;
  background-color: #FFFFFF;
  border-radius: 10px;
}

.cpjsBox{
  width: 1920px;
  margin: 0 auto;
  padding: 100px 0px;
  //background-image: url("https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg");
  background-size:100% 100%;
  display: flex;
  align-items: center;
}
.cpjs_ze{
  width: 1176px;
  justify-content: space-between;
  margin: 0px auto 30px;
}
.cpjsHeader{
  width: 1176px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px auto 30px;
}
.cpjs_left{
  font-family: SourceHanSansCN;
  font-size: 30px;
  color: #FFFFFF;
  letter-spacing: 0.64px;
  text-align: justify;
}
.cpjs_right{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: justify;
  cursor: pointer;
}

</style>




// WEBPACK FOOTER //
// src/components/en/image/cpjs.vue